export const caseModal = () => {
  const modal = document.querySelector(".js-case-modal");
  const modalOpenBtns = document.querySelectorAll(".js-case-modal-open");
  const modalCloseBtns = document.querySelectorAll("[data-modal-close]");

  modalOpenBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      modal.classList.add("is-visible");
      const modalId = this.dataset.caseModalId;

      const modalContent = modal.querySelector(`#${modalId}`);
      modalContent.classList.add("is-active");

      document.body.classList.add("is-modal-open");
    });
  });

  modalCloseBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      modal.classList.remove("is-visible");
      const modalContent = modal.querySelector(".is-active");
      modalContent.classList.remove("is-active");

      document.body.classList.remove("is-modal-open");
    });
  });
};
